;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.condSelect = (function () {
    const initialize = function () {
      $('.js-select').on('change', function (e) {
        const $el = $(e.target)
        const value = $el.val()
        // console.log('el val: ', value);
        if ($el.hasClass('howhear')) {
          $('.howhearother-wrap').hide()
          $('.howhearevent-wrap').hide()
          if (value === 'Other') {
            $('.howhearother-wrap').show()
          } else if (value === 'Event') {
            $('.howhearevent-wrap').show()
          }
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.condSelect.initialize()
  })
}(jQuery, window))
